/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { Injectable } from '@angular/core';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { AppModel } from '@app/models/app.model';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class AppsListService extends ApiBaseService {
  private _appsList: AppModel[] = [];
  protected _endpoint = 'apps';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get appsList(): AppModel[] {
    return this._appsList;
  }

  set appsList(value: AppModel[]) {
    this._appsList = value;
  }
  /**
   *  Warren Dowey
   *
   *  getAppById
   *
   * : Get an app from the list based on the id
   *
   * @param appID of type string
   *
   * @returns Void: gets the app that matches the ID or Null
   */
  getAppById(appId: string): AppModel {
    for (const app of this.appsList) {
      if (app.appId === appId) {
        return app;
      }
    }
    return null;
  }
  /**
   *  Warren Dowey
   *
   *  getAppBySlug
   *
   * : Get an app from the list based on the slug
   *
   * @param slug of type string
   *
   * @returns Void: gets the app with the slug that meets the query or Null
   */
  getAppBySlug(slug: string): AppModel {
    for (const app of this.appsList) {
      if (app.appSlug === slug) {
        return app;
      }
    }
    return null;
  }
  /**
   *  Warren Dowey
   *
   *  addToList
   *
   * : Add an app to the applist
   *
   * @param data of type AppModel
   *
   * @returns Void: push to the current app list
   */
  addToList(data: AppModel): void {
    this.appsList.push(data);
  }
  /**
   *  Warren Dowey
   *
   *  removeFromList
   *
   * : remove an app from the applist
   *
   * @param data of type AppModel
   *
   * @returns Void: remove from the current app list
   */
  removeFromList(data: AppModel): void {
    let index = 0;
    for (const app of this.appsList) {
      if (app.appId === data.appId) {
        this.appsList.slice(index, 1);
      }
      index++;
    }
  }
  /**
   *  Warren Dowey
   *
   *  updateInList
   *
   * : update an app from the applist based on the appid
   *
   * @param data of type AppModel
   *
   * @returns Void: update the app from the list
   */
  updateInList(data: AppModel): void {
    for (let app of this.appsList) {
      if (app.appId === data.appId) {
        app = data;
      }
    }
  }
  /**
   *  Warren Dowey
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type any
   *
   * @returns Void: construct the data from the list
   */
  protected handleData(data: any) {
    this.appsList = [];
    let app: AppModel;
    super.handleData(data);
    for (const item of data) {
      app = new AppModel();
      this.addToList(app.fromJson(item));
    }
  }
}
